/**
 * Hakkında + yardım sayfası.
 */
import { appState } from '../state';
import { applyStyle, escapeHtml } from '../ui/css';
import { createCard } from '../ui/components/card';
import { createPageHeader } from '../ui/components/pageHeader';
export function renderAbout() {
    const root = document.createElement('div');
    root.append(createPageHeader({
        title: 'PhotonRemote',
        highlight: 'hakkında',
        subtitle: 'Düşük gecikmeli, uçtan uca şifreli uzak masaüstü.',
    }));
    // Sürüm + intro kartı
    const versionCard = createCard({
        caption: 'SÜRÜM',
        title: 'PhotonRemote Web Controller',
    });
    const versionBody = document.createElement('div');
    applyStyle(versionBody, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)', marginTop: 'var(--sp-3)' });
    versionBody.innerHTML = `
    <div style="display:flex;justify-content:space-between;padding:8px 0;border-bottom:1px solid var(--border-subtle);align-items:center">
      <span style="font-size:var(--fs-caption);color:var(--text-tertiary);letter-spacing:0.08em">WEB CONTROLLER</span>
      <code id="web-ver" style="font-family:var(--font-mono);color:var(--accent);font-size:var(--fs-body)">0.1.0</code>
    </div>
    <div style="display:flex;justify-content:space-between;padding:8px 0;align-items:center">
      <span style="font-size:var(--fs-caption);color:var(--text-tertiary);letter-spacing:0.08em">BACKEND API</span>
      <code id="be-ver" style="font-family:var(--font-mono);color:var(--text-secondary);font-size:var(--fs-caption)">yükleniyor...</code>
    </div>
    <p style="margin:var(--sp-3) 0 0;font-size:var(--fs-caption);color:var(--text-secondary);line-height:1.6">
      Kurumsal güvenlik standartlarında (uçtan uca şifreleme, MFA, WebAuthn,
      denetim kaydı, RBAC, MDM politikası) tasarlandı.
    </p>
  `;
    versionCard.append(versionBody);
    // Sağlık göstergeleri
    const healthCard = createCard({
        caption: 'BAĞLANTI ROZETLERİ',
        title: 'Sağlık göstergeleri',
    });
    const healthBody = document.createElement('div');
    applyStyle(healthBody, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-3)', marginTop: 'var(--sp-3)' });
    healthBody.innerHTML = `
    ${healthRow('var(--status-online)', 'Sağlıklı', 'paket düzenli geliyor')}
    ${healthRow('var(--status-busy)', 'Zayıf', '1.5 saniyedir paket yok, jitter veya ağ yavaşlığı')}
    ${healthRow('var(--status-error)', 'Kopuk', '4 saniye paket yok, otomatik yeniden bağlanma / keyframe ister')}
  `;
    healthCard.append(healthBody);
    const grid = document.createElement('div');
    grid.classList.add('pr-grid-cards');
    applyStyle(grid, {
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fit, minmax(360px, 1fr))',
        gap: 'var(--sp-4)',
        marginBottom: 'var(--sp-5)',
    });
    grid.append(versionCard, healthCard);
    root.append(grid);
    // SSS
    const faqCard = createCard({
        caption: 'SSS',
        title: 'Sık sorulan sorular',
    });
    const faqBody = document.createElement('div');
    applyStyle(faqBody, { display: 'flex', flexDirection: 'column', gap: 'var(--sp-2)', marginTop: 'var(--sp-3)' });
    faqBody.innerHTML = `
    ${faqItem('Ekran görünüyor ama klavyem çalışmıyor', `Canvas'a bir kez tıkla (odaklanmak için). Tarayıcı bazı tuşları kendi yakalayabilir (F11, Ctrl+N); bu beklenen davranış.`)}
    ${faqItem('Ses duyulmuyor', `Tarayıcılar otomatik ses oynatımını kısıtlar. Oturuma girdikten sonra herhangi bir butona bir kez tıkla — AudioContext başlar. Mute butonu aktifse 🔈 olarak görünür.`)}
    ${faqItem('Pano senkronizasyonu çalışmıyor', `Tarayıcı Clipboard API kullanıcı izni ister. Sayfaya odaklanmışken Ctrl+V yaparken tarayıcı izin soracaktır.`)}
    ${faqItem('Bağlantı kopuyor', `Ağ yarı-açık kalıyorsa signaling 300 saniyelik idle sonrası otomatik kapatır. Yeniden oturum aç.`)}
    ${faqItem('Tam özellikli masaüstü uygulaması var mı?', `Evet — Windows için WinUI 3 uygulaması <a href="https://photondownload.com" style="color:var(--accent)">photondownload.com</a> üzerinden indirilebilir. Tam özellikli (4K, DXVA HW decode, ses, dosya, kayıt, admin).`)}
  `;
    faqCard.append(faqBody);
    applyStyle(faqCard, { marginBottom: 'var(--sp-5)' });
    root.append(faqCard);
    // Lisanslar / footer
    const footer = document.createElement('div');
    applyStyle(footer, {
        fontSize: 'var(--fs-caption)',
        color: 'var(--text-tertiary)',
        padding: 'var(--sp-4) 0',
        borderTop: '1px solid var(--border-subtle)',
        display: 'flex',
        flexDirection: 'column',
        gap: '4px',
    });
    footer.innerHTML = `
    <div>
      Açık kaynak:
      <a href="https://www.typescriptlang.org" target="_blank" style="color:var(--accent)">TypeScript</a> +
      <a href="https://vitejs.dev" target="_blank" style="color:var(--accent)">Vite</a> ·
      <a href="https://github.com/paulmillr/noble-ciphers" target="_blank" style="color:var(--accent)">@noble/ciphers</a> ·
      WebCodecs API · Let's Encrypt
    </div>
    <div>Giriş yapan: <strong style="color:var(--text-secondary)">${escapeHtml(appState.userEmail ?? '(giriş yapılmadı)')}</strong></div>
  `;
    root.append(footer);
    // Backend sürümünü fetch et
    void (async () => {
        try {
            const r = await fetch(`${appState.backendUrl}/version`);
            if (r.ok) {
                const v = await r.json();
                const beEl = root.querySelector('#be-ver');
                if (beEl)
                    beEl.textContent = `${v.backendVersion} (${v.backendInformational})`;
            }
        }
        catch { /* sessiz */ }
    })();
    return root;
}
function healthRow(color, name, desc) {
    return `
    <div style="display:flex;align-items:center;gap:var(--sp-3);padding:8px 0">
      <span style="display:inline-block;width:10px;height:10px;border-radius:50%;background:${color};box-shadow:0 0 0 4px ${color}33;flex-shrink:0"></span>
      <div style="display:flex;flex-direction:column">
        <strong style="color:var(--text-primary);font-size:var(--fs-body)">${escapeHtml(name)}</strong>
        <span style="color:var(--text-tertiary);font-size:var(--fs-caption)">${escapeHtml(desc)}</span>
      </div>
    </div>
  `;
}
function faqItem(q, a) {
    return `
    <details style="background:var(--bg-elev-3);border:1px solid var(--border-subtle);border-radius:var(--radius-sm);padding:0;overflow:hidden">
      <summary style="cursor:pointer;padding:12px 16px;font-weight:500;color:var(--text-primary);list-style:none;display:flex;align-items:center;justify-content:space-between">
        <span>${escapeHtml(q)}</span>
        <span style="color:var(--text-tertiary);font-family:var(--font-mono)">+</span>
      </summary>
      <div style="padding:0 16px 14px;color:var(--text-secondary);font-size:var(--fs-caption);line-height:1.6">${a}</div>
    </details>
  `;
}
